import { Button as AntButton } from 'antd';
import { ButtonProps as AntButtonProps } from 'antd';
import { darken } from 'polished';
import styled, { css } from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type ButtonProps = AntButtonProps & {
  $uppercase?: boolean;
  $bold?: boolean;
  $login?: boolean;
  $block?: boolean;
  $secondaryLink?: boolean;
  $vertical?: boolean;
  $reverse?: boolean;
  $customIcon?: boolean;
};

const Button = styled(AntButton)<ButtonProps>`
  &.ant-btn {
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${({ $login }) => ($login ? '50px' : '40px')};
    width: ${({ $login, $block }) => ($block ? '100%' : $login ? '180px' : '')};

    font-weight: ${({ $bold }) => ($bold ? 'bold' : 'normal')};
    text-transform: ${({ $uppercase }) => ($uppercase ? 'uppercase' : 'initial')};
  }

  &.ant-btn-primary {
    background-color: ${COLOR.CHEMISTRY};

    &:hover,
    &:focus {
      background-color: ${darken(0.15, COLOR.CHEMISTRY)};
    }
  }

  &.ant-btn-default {
    background-color: transparent;
    border-color: ${COLOR.CHEMISTRY};
    color: ${COLOR.CHEMISTRY};

    &:hover,
    &:focus {
      background-color: ${COLOR.CHEMISTRY};
      color: ${COLOR.WHITE};
    }
  }

  &.ant-btn-text {
    height: ${({ $vertical }) => ($vertical ? '60px' : '')};
    color: ${COLOR.OUTER_SPACE};
    display: flex;
    gap: 8px;
    flex-direction: ${({ $vertical, $reverse }) =>
      $vertical ? ($reverse ? 'column-reverse' : 'column') : $reverse ? 'row-reverse' : 'row'};
    justify-content: center;
    align-items: center;

    ${({ $customIcon }) =>
      $customIcon
        ? ''
        : css<ButtonProps>`
            svg {
              font-size: 20px;
              fill: ${COLOR.CHEMISTRY};
            }
          `}
  }

  &.ant-btn-link {
    text-decoration: underline;
    color: ${({ $secondaryLink }) => ($secondaryLink ? COLOR.OUTER_SPACE : COLOR.CHEMISTRY)};
    font-size: 12px;
    padding: 0px;
  }
`;

export default Button;
